import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  companies: [
    {
      currentLoans: [],
    },
  ],
  calculationData: null,
};

const mortgageCycleSlice = createSlice({
  name: 'mortgageCycle',
  initialState,
  reducers: {
    updateMortgageCycle: (state, action) => ({ ...state, ...action.payload }),
    resetMortgageCycle: () => initialState,
  },
});

export const { updateMortgageCycle, resetMortgageCycle } = mortgageCycleSlice.actions;
export default mortgageCycleSlice.reducer;
